module.exports = __webpack_public_path__ + "img/cand-approval-line.a6676daf.svg";